import JobApplicationLogin from './JobApplicationLogin.page';

export default JobApplicationLogin;